import { FC } from 'react';

import type { SaleItem } from '../../types';

import * as S from './SaleCard.styles';

interface SaleCardProps {
  dc: SaleItem | null;
  spinnerHidden: boolean;
  onBuyClick: () => void;
  containerRef: (el: HTMLDivElement | null) => void;
  canvasRef: (el: HTMLCanvasElement | null) => void;
}

export const SaleCard: FC<SaleCardProps> = ({
  dc,
  spinnerHidden,
  onBuyClick,
  containerRef,
  canvasRef,
}) => {
  if (!dc) {
    return (
      <S.Root>
        <S.CardViewer ref={containerRef}>
          <S.LoadingSpinner $hidden={spinnerHidden} />
          <S.Canvas ref={canvasRef} />
        </S.CardViewer>
      </S.Root>
    );
  }

  const specs = [
    ['Memory:', dc.memory],
    ['Tensor Nodes:', dc.nodes],
    ['Plasma Energy:', dc.energy],
    ['Reactor Type:', dc.reactor],
    ['Query Tier Access:', dc.access],
  ];

  const tokens = [
    // ['Token Allocation:', dc.tokens],
    // ['Emission Rate:', dc.emission],
    // ['Token FDV:', dc.fdv],
    ['Token Allocation:', '—'],
    ['Emission Rate:', '—'],
    ['Token FDV:', '—'],
  ];

  let buyText = '';
  if (dc.status === 'out-of-stock') buyText = 'Out of Stock';
  else if (dc.status === 'preorder') buyText = 'Pre-order ' + dc.price + '\u039E';
  else buyText = 'Buy for ' + dc.price + '\u039E';

  let statusText = '';
  if (dc.status === 'out-of-stock') statusText = 'Currently unavailable';
  else if (dc.status === 'preorder') statusText = 'Pre-order \u2014 March 2026';

  return (
    <S.Root>
      <S.CardViewer ref={containerRef}>
        <S.LoadingSpinner $hidden={spinnerHidden} />
        <S.Canvas ref={canvasRef} />
      </S.CardViewer>
      <S.CardName>{dc.name}</S.CardName>
      <S.CardSpecs>
        {specs.map(([label, val]) => (
          <S.SpecRow key={label}>
            <S.SpecLabel>{label}</S.SpecLabel>
            <S.SpecVal>{val}</S.SpecVal>
          </S.SpecRow>
        ))}
      </S.CardSpecs>
      <S.CardTokens>
        {tokens.map(([label, val]) => (
          <S.TokenRow key={label}>
            <S.TokenLabel>{label}</S.TokenLabel>
            <S.TokenVal>{val}</S.TokenVal>
          </S.TokenRow>
        ))}
      </S.CardTokens>
      <S.BuyBtn $status={dc.status || undefined} onClick={onBuyClick}>
        {/* {buyText} */}
        BUY
      </S.BuyBtn>
      <S.CardStatus>{statusText}</S.CardStatus>
    </S.Root>
  );
};
